import {Draggable, Scrollbar} from '@priority-software/priority-style-react';
import React, {useCallback, useContext, useEffect, useMemo, useRef} from 'react';

import {AppSearchesContext} from '../AppSearchesContext';
import FilterBox from './FilterBox/FilterBox';
import styles from './styles.module.scss';
import ChooseFieldDropdown from './ChooseFieldDropdown';
import DraggableList from '../../../components/Common/DraggableList';

const FilterList = () => {
    const {
        filters,
        formSession,
        handleRemoveFilter,
        handleUpdateFilter,
        onUpdateFiltersOrder,
        getColumnByID
    } = useContext(AppSearchesContext);

    const scrollBarRef = useRef(null);
    const currentLength = useRef<number>(filters.length);

    const onUpdateFilter = useCallback(
        (id, filter) => {
            handleUpdateFilter(id, filter);
        },
        [handleUpdateFilter]
    );

    const scrollToBottom = () => {
        if (scrollBarRef?.current) scrollBarRef.current.scrollToBottom();
    };

    const checkScrollToBottom = index => () => {
        if (index === filters.length - 1) {
            scrollToBottom();
        }
    };

    useEffect(() => {
        const prevLength = currentLength?.current;
        if (prevLength > 0 && prevLength < filters.length) {
            scrollToBottom();
        }

        currentLength.current = filters.length;
    }, [filters?.length]);

    const onRemoveFilter = id => {
        handleRemoveFilter(id);
    };

    const onReorderd = filtersReorderd => {
        onUpdateFiltersOrder(filtersReorderd);
    };

    const List = useMemo(
        () => (
            <DraggableList
                keyExtractor={item => `${item.title} ${item.columnID}`}
                draggable
                handleDNDFinish={filtersReorderd => onReorderd(filtersReorderd)}
                data={filters}
                renderItem={({item, ...dragProps}) => (
                    <Draggable
                        key={`${item.title} ${item.columnID}`}
                        {...dragProps}
                        iconPosition="center"
                    >
                        <FilterBox
                            componentClasses={styles.filterListItem}
                            session={formSession}
                            onRemoveFilter={id => onRemoveFilter(id)}
                            onUpdateFilter={filter => onUpdateFilter(filter.columnID, filter)}
                            filter={item}
                            scrollToBottom={checkScrollToBottom(dragProps.index)}
                            column={getColumnByID(item.columnID)}
                        />
                    </Draggable>
                )}
            />
        ),
        [filters, formSession]
    );

    return (
        <>
            <Scrollbar scrollbarRef={scrollBarRef} componentClasses={styles.filterList}>
                <div className={styles.listWrapper}>
                    {List}
                    <ChooseFieldDropdown />
                </div>
            </Scrollbar>
        </>
    );
};

export default FilterList;
